import { generatePath } from 'react-router';

export const paths = createPaths();

export function createPaths() {
  return {
    profileAccess: path('/'),
    confirmEmail: path('/evaluators/:evaluatorLinkId'),

    exploreProfile: path('/profile/explore/:profileId'),
    exploreTheme: path('/profile/explore/:profileId/:theme'),

    discoveryProfile: path('/profile/discovery/:profileId'),
    discoveryInterview: path('/profile/discovery/:profileId/interview'),
    discoveryManagement: path('/profile/discovery/:profileId/management'),
    discoveryPersonalAchievement: path(
      '/profile/discovery/:profileId/personal-achievement',
    ),
    discoveryEffectiveSelling: path(
      '/profile/discovery/:profileId/effective-selling',
    ),
    discoveryCriticalThinking: path(
      '/profile/discovery/:profileId/critical-thinking',
    ),
    discoveryUnknownChapter: path('/profile/discovery/:profileId/*'),

    impactProfile: path('/profile/impact/:profileId'),

    discoveryEvaluator: path('/evaluator/discovery'),
    discoveryEvaluatorWelcome: path('/evaluator/discovery/welcome'),
    discoveryEvaluatorAboutYou1: path('/evaluator/discovery/about-you-1'),
    discoveryEvaluatorAboutYou2: path('/evaluator/discovery/about-you-2'),
    discoveryEvaluatorInstructions: path('/evaluator/discovery/instructions'),
    discoveryEvaluatorQuestions: path('/evaluator/discovery/questions'),
    discoveryEvaluatorComplete: path('/evaluator/discovery/complete'),

    discoveryApiEvaluator: path('/evaluator/discovery-api'),
    discoveryApiEvaluatorWelcome: path('/evaluator/discovery-api/welcome'),
    discoveryApiEvaluatorAboutYou1: path(
      '/evaluator/discovery-api/about-you-1',
    ),
    discoveryApiEvaluatorAboutYou2: path(
      '/evaluator/discovery-api/about-you-2',
    ),
    discoveryApiEvaluatorInstructions: path(
      '/evaluator/discovery-api/instructions',
    ),
    discoveryApiEvaluatorQuestions: path('/evaluator/discovery-api/questions'),
    discoveryApiEvaluatorComplete: path('/evaluator/discovery-api/complete'),

    exploreEvaluator: path('/evaluator/explore'),
    exploreEvaluatorWelcome: path('/evaluator/explore/welcome'),
    exploreEvaluatorAboutYou1: path('/evaluator/explore/about-you-1'),
    exploreEvaluatorAboutYou2: path('/evaluator/explore/about-you-2'),
    exploreEvaluatorInstructions: path('/evaluator/explore/instructions'),
    exploreEvaluatorQuestions: path('/evaluator/explore/questions'),
    exploreEvaluatorComplete: path('/evaluator/explore/complete'),

    discoveryFullCircleEvaluator: path('/evaluator/discovery-full-circle'),
    discoveryFullCircleEvaluatorWelcome: path(
      '/evaluator/discovery-full-circle/welcome',
    ),
    discoveryFullCircleEvaluatorAboutYou: path(
      '/evaluator/discovery-full-circle/about-you',
    ),
    discoveryFullCircleEvaluatorInstructions: path(
      '/evaluator/discovery-full-circle/instructions',
    ),
    discoveryFullCircleEvaluatorQuestions: path(
      '/evaluator/discovery-full-circle/questions',
    ),
    discoveryFullCircleEvaluatorComplete: path(
      '/evaluator/discovery-full-circle/complete',
    ),

    tpaEvaluator: path('/evaluator/tpa'),
    tpaEvaluatorWelcome: path('/evaluator/tpa/welcome'),
    tpaEvaluatorGetStarted: path('/evaluator/tpa/getstarted'),
    tpaEvaluatorComplete: path('/evaluator/tpa/complete'),
  } as const;
}

function path<Path extends string>(pattern: Path) {
  type Params = Parameters<typeof generatePath<Path>>[1];
  return {
    path: pattern,
    href: (params: Params) => generatePath(pattern, params),
  };
}
